import { render, staticRenderFns } from "./SingleServicePriceEditTable.vue?vue&type=template&id=80d72b54&scoped=true&"
import script from "./SingleServicePriceEditTable.vue?vue&type=script&lang=js&"
export * from "./SingleServicePriceEditTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleServicePriceEditTable.vue?vue&type=style&index=0&id=80d72b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d72b54",
  null
  
)

/* custom blocks */
import block0 from "./SingleServicePriceEditTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VEditDialog,VTextField,VTooltip})
